import React from "react";
import { sumDataByKeys } from "../../Block charts/ChartDataHelper";
import { secondsToTime, timeToSeconds } from "../../../../Utilitie";
const SWBTable = ({ data }) => {
  const sectionHead = [
    "section",
    "Demanded",
    "Agreed",
    "Availed",
    "Availed Hrs",
  ];
  const section = [...new Set(data.map((o) => o.section))];
  const stationHEad = [
    "Block section CODE",
    "Demanded",
    "Agreed",
    "Availed",
    "Availed Hrs",
  ];
  return (
    <div className="">
      <div className="row">
        <div className="col-md-6 ">
          <div className="newUiBody">
            <div className="table-responsive">
              <table className="table table-hover table-striped newUiTable">
                <thead>
                  <tr>
                    {sectionHead.map((sh, i) => (
                      <th key={i}>{sh}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {section.map((s, j) => {
                    return (
                      <tr key={j}>
                        <td>{s}</td>
                        <td>
                          {" "}
                          {data.reduce((sum, acc) => {
                            return acc.section === s
                              ? sum + acc.No_Of_Demand_By_Engg
                              : sum;
                          }, 0)}
                        </td>{" "}
                        <td>
                          {" "}
                          {data.reduce((sum, acc) => {
                            return acc.section === s
                              ? sum + acc.No_Of_Demand_Agreed_GIVEN
                              : sum;
                          }, 0)}
                        </td>{" "}
                        <td>
                          {" "}
                          {data.reduce((sum, acc) => {
                            return acc.section === s &&
                              acc.Availed_Not == "AVAILED"
                              ? sum + 1
                              : sum;
                          }, 0)}
                        </td>{" "}
                        <td>
                          {" "}
                          {secondsToTime(
                            data.reduce((sum, acc) => {
                              return acc.section === s
                                ? sum + timeToSeconds(acc.Availed)
                                : sum;
                            }, 0),
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>{" "}
        </div>
        <div className="col-md-6">
          <div className="newUiBody"></div>{" "}
        </div>
      </div>
    </div>
  );
};
export default SWBTable;
